export function generateSequentialPromocode(promocode: string, count: number) {
  const promoCodes: string[] = [];
  for (let i = 1; i < count + 1; i++) {
    promoCodes.push(`${promocode}${i}`);
  }

  return promoCodes;
}
